import { Component, OnInit } from "@angular/core";
import {
	ElementRef,
	Renderer2,
} from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Input, EventEmitter, Output, OnDestroy, ChangeDetectionStrategy } from "@angular/core";

//import { KioskService } from "../kiosk.service";
import { LocalStorageService } from "@dodo/local-storage/trycatch-local-storage.service";
import { QualificationError } from "app/_core/_models/qualification.models";
import { Auth0User } from "app/_core/services/models/auth0-user.model";
import { Auth0Service } from "app/_core/services/auth0.service";
import { DodoService } from "app/_core/services/models/dodo-service.model";
import { FormStatus } from "app/_core/services/models/types";
import { WebApiService, JsonFileService } from "_libs/web-api";
import { filter, takeUntil } from "rxjs/operators";
import { Subject, BehaviorSubject} from "rxjs";
import { LocalStorageKeys } from "app/_core/services/local-storage-state-restor.service";
// import { Zeus } from "app/_core/services/models/zeus.models";
import { DebugService } from "app/_core/services/debug.service";
import { Global } from "app/_core/services/models/global";
import { TealiumService } from "tealium/services/tealium.service";
import { BoboPaymentService } from "../bobo-payment-service";






declare let Payment: any;

const IFRAME_CONTENT_LOADING = "iframe content for payment page is loading.";
const IPSI_FORM_RENDERED = "The payment form has rendered.";
const IPSI_SUBMISSION_INIT = "The payment form has been submitted.";
const PAYMENT_OUTCOME_RECEIVED = "Payment outcome for the transaction.";

@Component({
    selector: "bobo-payment",
    templateUrl: "./bobo-payment.component.html",
    styleUrls: ["./bobo-payment.component.scss"],
    standalone: false
})
export class BoboPaymentComponent implements OnInit, OnDestroy {
	public _paymentDeclined = false;

	public _paymentErrorMessage =
		"Your payment has been unsuccessful, please try again. If this error persists, please contact our sales team on 13 36 36";
	private __ipsiSubmitPaymentNotTriggered: any;
	public iframePayment: any;

	public iframe: any; //Zeus.Payment.iFrameUrlResponse;

	_appearance = "fill";
	_form: FormGroup;
	public showPaymentScreen = false;
	public _virtualKeyboardIframe = false;
	public busy = false;
	private __status: FormStatus = "INVALID";
	private _refId: string;
	public reload = false;
	paymentSuccessful = false;
	paymentError = "";

	set Status(status: FormStatus) {
		if (status !== this.__status) {
			this.__status = status;
			//this.isValid.emit(this.__status);
		}
	}
	
	set Busy(busy: boolean) {
		this.busy = busy;
		//this.busyStatus.emit(busy);
	}

	destroyed$ = new Subject<boolean>();
	public paymentReference$: BehaviorSubject<any>;


	constructor(
		private __fb: FormBuilder,
		private __localstorage: LocalStorageService,
		private __webApiService: WebApiService,
		private log: DebugService,
		private renderer: Renderer2,
		private er: ElementRef,
		private __tealiumService: TealiumService,
		private __router: Router,
		private __boboPaymentService: BoboPaymentService,
	) {
		this.__buildForm();
		this.paymentReference$ = new BehaviorSubject<any>(undefined);
	}

	ngOnInit(): void {
	}

	private __buildForm(): void {
		this._form = this.__fb.group({
			reference: ["", [Validators.maxLength(8)]]
		});
	}

	ngOnDestroy() {
		this.destroyed$.next(true);
		this.destroyed$.complete();
	}

	gotoPayment() {
		const ref = this._form.get("reference").value;
		if (ref) {
			this.__boboPaymentService.paymentSmsReference = ref;
			const url = `/payment-details`;
			this.__router.navigate([url]);
		} else {
		}
	}
}
